import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const CORSChecker = () => {
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting, isDirty, isValid },
  } = useForm({ mode: "onChange" });
  const [convertedValue, setConvertedValue] = useState(null);
  const [error, setError] = useState(null);

  const faqs = [
    {
      title: "What is CORS?",
      desc: "CORS (Cross-Origin Resource Sharing) is a browser security feature that restricts web pages from making requests to a different origin (domain) than the one it originated from, preventing unauthorized access to resources and enhancing web security.",
    },
    {
      title: "What is CORS used for?",
      desc: "CORS (Cross-Origin Resource Sharing) is used for enforcing browser security policies that prevent web pages from making cross-origin requests (requests to a different domain) to protect sensitive data and prevent unauthorized access to resources. It allows servers to control which origins can access their resources and enables secure communication between web applications from different domains. CORS is essential for ensuring web application security and preventing potential security vulnerabilities like cross-site request forgery (CSRF) and cross-site scripting (XSS) attacks.",
    }
  ];

  const onSubmit = async (data) => {
    try {
      const response = await fetch(data.url, {
        method: "HEAD",
        mode: "no-cors",
      });
      if (response.ok) {
        setConvertedValue(`CORS is enabled for ${data.url}`); // CORS is enabled for the given URL
      } else {
        setConvertedValue(`CORS is not enabled for ${data.url}`); // CORS is not enabled or there was an error
      }
    } catch (error) {
      setConvertedValue(`Unable to check CORS for ${data.url}`); // An error occurred while making the request
    }
  };

  return (
    <section className="landing-page-section bg-landing-page">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-xl-8 col-lg-8 col-md-8">
            <div className="section-title text-center title-ex1 mb-4">
              <p>
                <Link className="" to={"/utilities"}>
                  ← All Developer Utilities
                </Link>{" "}
              </p>
              <h2 className="light-purple-gradient">CORS Checker</h2>
              <p
                className="landing-muted-text"
                style={{ fontSize: "large", fontWeight: "normal" }}
              >
                Check for cors headers of provided URL.
              </p>
            </div>
          </div>

          <Container>
            <Row className="dark-mode justify-content-center mb-4">
              <Col lg={12} md={8} className="">
                <form className="form" onSubmit={handleSubmit(onSubmit)}>
                  <label className="text-cool-black d-flex justify-content-center text-left">
                    URL
                  </label>
                  <div className="form-row justify-content-center">
                    <div className="form-group col-md-4">
                      <input
                        name="url"
                        className="form-control"
                        ref={register({
                          required: true,
                          pattern: {
                            value:
                              /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                            message: "Please enter a valid URL",
                          },
                        })}
                        placeholder="https://yoururl.com"
                      />
                      {errors.message && (
                        <p className="error">Value is required</p>
                      )}
                      {error && <p className="error">{error}</p>}
                    </div>
                  </div>
                  <div className="d-flex mt-1 justify-content-center">
                    <div className="form-group">
                      <button
                        className="btn btn-danger btn-block gradient-bg-accent"
                        type="submit"
                      >
                        {isSubmitting ? 'Checking...' : 'Check'}
                      </button>
                    </div>
                  </div>
                </form>
                {convertedValue && (
                  <div className="form justify-content-center pt-0">
                    <label className="text-cool-black d-flex justify-content-center text-center">
                      CORS Information{" "}
                    </label>
                    <p className="text-center">{convertedValue}</p>
                  </div>
                )}
              </Col>
            </Row>
            <Row>
              {faqs.map((faq, key) => (
                <Col className="mt-10" key={key} lg={6} md={6}>
                  <div style={{ textAlign: "left" }}>
                    <div className="d-flex justify-content-start">
                      <div
                        style={{ marginBottom: "0px", paddingRight: "4px" }}
                      ></div>
                      <h5 className="text-white">{faq.title}</h5>
                    </div>

                    <p
                      className="landing-muted-text mb-4"
                      style={{ fontSize: "1rem" }}
                    >
                      {faq.desc}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
            <Row className="justify-content-center mt-10 mb-4">
              <Col lg={12} md={8} className="">
                <div className="title text-center m-4">
                  <h1 className="font-weight-bolder line-height-1_4 text-white">
                    Easily{" "}
                    <span className="light-purple-gradient">force update</span>{" "}
                    your mobile apps.
                  </h1>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg={6} md={8}>
                <div className="title text-center mb-5">
                  <span
                    className="text-white text-landing-h1"
                    style={{ fontSize: "2.0rem" }}
                  >
                    Start with{" "}
                    <span className="light-purple-gradient">App Upgrade</span>,
                    today.
                  </span>
                  <p
                    className="light-purple-gradient mt-3"
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "normal",
                      color: "rgba(144, 97, 249,1)",
                    }}
                  >
                    Start with <b>free 15 days</b> trial. No credit card
                    required.
                  </p>
                </div>
                <div
                  className="mt-5"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    gap: "1.5rem",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <a
                      target="_blank"
                      href="https://appupgrade.dev/signup"
                      className="btn btn-cta btn-full-width outline-text glowing outline-shadow"
                      rel="noreferrer"
                    >
                      Get started →
                    </a>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <a
                      target="_blank"
                      href="mailto:support@appupgrade.dev"
                      className="btn btn-cta btn-full-width outline-text glowing outline-shadow"
                      rel="noreferrer"
                      style={{ padding: ".375rem .75rem" }}
                    >
                      Contact us →
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </section>
  );
};

export default CORSChecker;
